// import React from 'react'
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { UserInformation } from './component/Detail';
import { PaymentMethod } from './component/PaymentMethod';
import { Transactions } from './component/Transactions';
import { ChargingSessions } from './component/ChargingSessions';
import { IdlingPenalty } from './component/IdlingPenalty';
import { Reservation } from './component/Reservation';
import { RewardPoints } from './component/RewardPoints';
import { Subscription } from './component/Subscription';
import { useUserDetail } from '../../../services/user/useUser';

const UserDetail = () => {
    const { id } = useParams();
    const { data: apiResponse } = useUserDetail(id!);
    const userDetail = apiResponse?.data;
    if (!userDetail) return null;

    return (
        <Grid container>
            <Grid item xs={12}>
                <UserInformation userDetail={userDetail} />
            </Grid>
            <Grid item xs={12}>
                <PaymentMethod userDetail={userDetail} />
            </Grid>
            <Grid item xs={12}>
                <Transactions userDetail={userDetail} />
            </Grid>
            <Grid item xs={12}>
                <ChargingSessions userDetail={userDetail} />
            </Grid>
            <Grid item xs={12}>
                <IdlingPenalty userDetail={userDetail} />
            </Grid>
            <Grid item xs={12}>
                <Reservation userDetail={userDetail} />
            </Grid>
            <Grid item xs={12}>
                <Subscription userDetail={userDetail} />
            </Grid>
            <Grid item xs={12}>
                <RewardPoints userDetail={userDetail} />
            </Grid>
        </Grid>
    )
}

export default UserDetail